import React from 'react';
import { Check } from 'lucide-react';
export function TargetAudience() {
  const targets = [{
    icon: '🎈',
    title: 'La que ya decora "de onda"',
    desc: 'Sos la que siempre termina armando la decoración de los cumples del grupo de amigas o de la familia. Todas te dicen "dedicate a esto" pero no sabés por dónde arrancar para cobrar.',
    bullets: ['Cómo pasar de hacerlo gratis a cobrarlo bien', 'Presupuesto claro para no perder plata en el camino']
  }, {
    icon: '🌸',
    title: 'La que quiere un ingreso extra',
    desc: 'Tenés tiempo, tenés buen ojo, pero no tenés un sistema. Con Decora Fácil PRO vas a poder ofrecer paquetes completos, desde un cumple infantil hasta un casamiento chico.',
    bullets: ['6 categorías de eventos ya armadas', 'Todo pensado para el bolsillo argentino']
  }, {
    icon: '💼',
    title: 'La que ya cobra pero quiere profesionalizarse',
    desc: 'Ya tenés algunos clientes, pero improvisás contratos, señas y presupuestos. El Plan PRO/Élite te da las herramientas para que te tomen en serio.',
    bullets: ['Plantillas de contratos y señas', 'Renders con IA antes de gastar un peso']
  }];
  return <section className="py-16 px-5 bg-wine text-white" data-id="element-231">
      <div className="max-w-md mx-auto" data-id="element-232">
        <h2 className="text-3xl font-bold text-center mb-10" data-id="element-233">
          ¿Esto es para vos?
        </h2>

        <div className="flex flex-col gap-6" data-id="element-234">
          {targets.map((target, idx) => <div key={idx} className="bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm" data-id="element-235">
              <div className="flex items-center gap-3 mb-4" data-id="element-236">
                <span className="text-2xl" data-id="element-237">{target.icon}</span>
                <h3 className="text-lg font-bold" data-id="element-238">{target.title}</h3>
              </div>
              <p className="text-[15px] text-white/80 leading-relaxed mb-5" data-id="element-239">
                {target.desc}
              </p>
              <ul className="space-y-2" data-id="element-240">
                {target.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-sm font-medium text-pink-pastel" data-id="element-241">
                    <Check className="w-4 h-4 shrink-0 mt-0.5" data-id="element-242" />
                    <span data-id="element-243">{bullet}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
}